import type { Language } from '@offer-catalog/services/i18n'
import type { CountryItem } from '@/types/countries'

export function getCountryName(countryCode: string, currentLanguage: Language) {
  if (!countryCode)
    return ''

  return new Intl.DisplayNames([currentLanguage], { type: 'region' }).of(
    countryCode.toUpperCase(),
  )
}

export function sortCountriesByName(countries: CountryItem[]): CountryItem[] {
  return countries.toSorted((a, b) => a.name.localeCompare(b.name))
}
